"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WEmployeeModal = class WEmployeeModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.item || this.$fn.schemaDefaults('CreateEmployee');
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    createTitle;
    editTitle;
    ux;
    dataMembers = ['resource', 'editor', 'createTitle', 'editTitle', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                createTitle: this.$fn.pgettext("Employeees", "Add employee"),
                editTitle: this.$fn.pgettext("Employeees", "Edit employee"),
                ux: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.employeeId == null ? this.createTitle : this.editTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8572_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_8578_getActionArgs($event) {
        return {
            result: {
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_closeComponent_8580_getActionArgs($event) {
        return {
            result: {},
        };
    }
    async act_1040167445267876_rest_8576_getActionArgs($event) {
        return {
            method: "save",
            container: this.parent.employees,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8572 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8572_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8571 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8572,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8571],
        });
        const act_2248226175642056_closeComponent_8574 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_8573 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_8574,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8573],
        });
        const act_1040167445267876_closeComponent_8578 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_8578_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_8577 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_8578,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_closeComponent_8580 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_8580_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_deleted_8579 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_8580,
            event: "deleted",
            displayName: "closeComponent",
        });
        const act_1040167445267876_rest_8576 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_8576_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_saved_8577, evh_1040167445267876_deleted_8579],
        });
        const evh_1040167445267876_submit_8575 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_8576,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8575],
        });
        const act_1419464017721962_closeComponent_8582 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_8581 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_8582,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_8581],
        });
        return {
            act_7315092382398562_closeModal_8572,
            evh_7315092382398562_close_8571,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_8574,
            evh_2248226175642056_close_8573,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_8578,
            evh_1040167445267876_saved_8577,
            act_1040167445267876_closeComponent_8580,
            evh_1040167445267876_deleted_8579,
            act_1040167445267876_rest_8576,
            evh_1040167445267876_submit_8575,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_8582,
            evh_1419464017721962_clickPreventStop_8581,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_rest_8576,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], WEmployeeModal.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WEmployeeModal.prototype, "onParent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], WEmployeeModal.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WEmployeeModal.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WEmployeeModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WEmployeeModal.prototype, "onSize", null);
WEmployeeModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], WEmployeeModal);
exports.default = WEmployeeModal;
vue_property_decorator_1.Vue.component("WEmployeeModal", WEmployeeModal);
